/** Short Georgian "time ago" text for an ISO date: "ახლახან", "5 წთ წინ", "3 სთ წინ", "2 დღის წინ". */
export function timeAgo(iso, now = Date.now()) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const sec = Math.max(0, Math.round((now - then) / 1000));
  if (sec < 60) return "ახლახან";
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} წთ წინ`;
  const hours = Math.round(min / 60);
  if (hours < 24) return `${hours} სთ წინ`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days} დღის წინ`;
  return new Date(then).toLocaleDateString("ka-GE", { year: "numeric", month: "2-digit", day: "2-digit" });
}
